import { render, staticRenderFns } from "./addQyCourse.vue?vue&type=template&id=fceff578&scoped=true"
import script from "./addQyCourse.vue?vue&type=script&lang=js"
export * from "./addQyCourse.vue?vue&type=script&lang=js"
import style0 from "./addQyCourse.vue?vue&type=style&index=0&id=fceff578&prod&lang=less"
import style1 from "./addQyCourse.vue?vue&type=style&index=1&id=fceff578&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fceff578",
  null
  
)

export default component.exports